<div class="p-grid container">
	<div class="relative card pb-6">

		<div *ngIf="data.length > 1 || selectedData.length > 1" class="absolute tag-positioning">
			<div class="heading-canvas mx-auto">
				<div class="flex tag-padding">
					<h6 class="dark-purple-text font-bold mb-0">
						<span class="text-white font-semibold tag-font-size"
						>{{ this.lastRequest?.start }}
							<span class="dark-purple-text font-bold tag-font-size">to</span
							><span></span
							></span>
						<span class="text-white font-semibold tag-font-size">
									{{ this.lastRequest?.finish }}
								</span>
					</h6>
				</div>
			</div>
		</div>

		<div id="mention_table">
			<div class="tyalls-table-name mb-3 flex justify-content-between pr-4">
				<h6 class="tyalls-table-heading">Team Analysis<span class="font-light"> - {{ currentProperty?.name }}</span></h6>
			</div>
		</div>

		<div class="p-3 max-w-xl">
			<div class="font-semibold mb-2">Team Audit Completion Performance</div>
			<ul class="list-disc pl-5 mb-2 text-sm">
				<li class="pb-3">
					<strong>Hours to Claim.</strong>
					Monitor how long it takes your team to claim tasks after they become available.
					Delays of more than 2 days may increase risk and delay other departments.
				</li>
				<li class="pb-3">
					<strong>Hours to Review.</strong>
					Track how long reviews take. Fast reviews increase the risk of overlooking discrepancies.
					Slower reviews can indicate problems with reports or forgotten tasks, leading to further bottlenecks.
				</li>
				<li class="pb-3">These insights can help to reduce missed revenue and other operational risks.</li>
				<li class="pb-3">
					Visit <a [routerLink]="['/report/tasks']" class="underline cursor-pointer">Task Analysis</a> to track your audit completion by report.
			</ul>
		</div>

		<form #formDir="ngForm" [formGroup]="tasksOverviewForm">
			<div class="p-field xl:flex justify-content-between mb-4 text-sm px-1">
				<div class="flex gap-2">
					<!-- Radio Buttons for Date Range -->
					<div class="p-field-radiobutton task-canvas mt-2 flex">
						<p-radioButton
							(click)="onDateRangeChange('current_month')"
							class="mr-2 cursor-pointer"
							formControlName="dateRangeOption"
							inputId="current_month"
							name="dateRangeOption"
							value="current_month"
						></p-radioButton>
						<div class="mr-1 content-center">
							<label class="cursor-pointer" for="current_month">Current Month</label>
						</div>
					</div>

					<div class="p-field-radiobutton task-canvas mt-2 flex">
						<p-radioButton
							(click)="onDateRangeChange('last_month')"
							class="mr-2 cursor-pointer"
							formControlName="dateRangeOption"
							inputId="last_month"
							name="dateRangeOption"
							value="last_month"
						></p-radioButton>
						<div class="mr-1 content-center">
							<label class="cursor-pointer" for="last_month">Last Month</label>
						</div>
					</div>

					<div class="p-field-radiobutton task-canvas mt-2 flex">
						<p-radioButton
							(click)="onDateRangeChange('last_week')"
							class="mr-2 cursor-pointer"
							formControlName="dateRangeOption"
							inputId="last_week"
							name="dateRangeOption"
							value="last_week"
						></p-radioButton>
						<div class="mr-1 content-center">
							<label class="cursor-pointer" for="last_week">Last Week</label>
						</div>
					</div>

					<div class="p-field-radiobutton task-canvas mt-2 flex">
						<p-radioButton
							(click)="onDateRangeChange('today')"
							class="mr-2 cursor-pointer"
							formControlName="dateRangeOption"
							inputId="today"
							name="dateRangeOption"
							value="today"
						></p-radioButton>
						<div class="mr-1 content-center">
							<label class="cursor-pointer" for="today">Today</label>
						</div>
					</div>
				</div>

				<!--				<div class="flex justify-content-end gap-4">-->
				<!--					<div class="w-13rem mt-2">-->
				<!--						<p-dropdown-->
				<!--							[options]="taskViewOptions"-->
				<!--							optionLabel="title"-->
				<!--							placeholder="Select a Task"-->
				<!--							(onChange)="onTaskChange($event)"-->
				<!--						></p-dropdown>-->
				<!--					</div>-->
				<!--				</div>-->
			</div>
		</form>

		<div class="flex px-6 gap-2">
			<div (click)="showTaskSelection()" class="expand-orange border-round-lg cursor-pointer">
				<i
					[ngClass]="taskSelection ? 'rotate-180' : 'rotate-0'"
					class="fa-sharp fa-solid fa-chevron-down"
					style="color: #f78100;"
				></i>
			</div>

			<div class="w-full">
				<div class="expand-orange w-full chart-text font-bold mb-2 px-4">
					<div class="flex justify-content-between">
						Team members
						<div class="flex">
							<div (click)="addAllStaff()" class="cursor-pointer text-sm mr-5 mt-1">Add team</div>
							<div (click)="resetChart()" class="cursor-pointer text-sm mt-1">Reset</div>
						</div>
					</div>
				</div>

				<div [@aiResponseAnimation]="taskSelection ? 'open' : 'closed'" class="flex gap-2 w-full">

					<!-- Available Tasks -->
					<div
						(dragover)="allowDrop($event)"
						(drop)="drop($event, 'allStaff')"
						class="drag-canvas p-3 flex flex-wrap gap-2"
					>
						<div *ngIf="data.length > 0"
								 class="flex flex-wrap gap-2">
							<div
								(dragstart)="dragStart($event, staff, 'allStaff')"
								*ngFor="let staff of data"
								class="task-card text-xs"
								draggable="true"
							>
								{{ staff.fullName }}
							</div>
						</div>
					</div>

					<!-- Selected Tasks -->
					<div
						(dragover)="allowDrop($event)"
						(drop)="drop($event, 'selectedData')"
						class="drop-canvas p-3 flex flex-wrap gap-2"
					>
						<div *ngIf="selectedData.length === 0" class="content-center text-center w-full">
							Drop team member
						</div>

						<div
							(dragstart)="dragStart($event, staff, 'selectedData')"
							*ngFor="let staff of selectedData"
							class="task-card text-xs"
							draggable="true"
						>
							{{ staff.fullName }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="px-6 mt-4">
			<canvas id="staffChart"></canvas>
		</div>

		<!-- Data Table -->
		<div *ngIf="selectedData.length !== 0"
				 class="p-6">
			<p-table
				[resizableColumns]="true"
				[value]="selectedData"
				styleClass="p-datatable-gridlines"
			>
				<ng-template pTemplate="header">
					<tr>
						<th class="text-sm" pResizableColumn>Group</th>
						<th class="text-center text-sm" pResizableColumn>Time to Claim</th>
						<th class="text-center text-sm" pResizableColumn>Time to Review</th>
						<th class="text-center text-sm" pResizableColumn>Total Claimed</th>
						<th class="text-center text-sm" pResizableColumn>Total Reviewed</th>
					</tr>
				</ng-template>

				<ng-template let-staff pTemplate="body">
					<tr>
						<td class="text-sm">{{ staff.fullName }}</td>
						<td class="text-center text-sm">{{ staff.avgTimeToClaim  | number: '1.2-2' }}</td>
						<td class="text-center text-sm">{{ staff.avgTimeToComplete | number: '1.2-2' }}</td>
						<td class="text-center text-sm">
							{{ staff.totalClaimed }}
						</td>
						<td class="text-center text-sm">
							{{ staff.totalCompleted }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

	</div>
</div>

